import { Heart } from "lucide-react";

function getCopyrightYears() {
  const startYear = 2024;
  const currentYear = new Date().getFullYear();
  return currentYear > startYear
    ? `${startYear}–${currentYear}`
    : startYear.toString();
}

export function Footer() {
  return (
    <footer className="bg-white border-t border-[#ece4e1] py-6 mt-8 sm:mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-4 min-h-[44px]">
          <div className="flex items-center space-x-2">
            <span className="text-sm text-[#431908] font-sans">Made with</span>
            <Heart className="h-4 w-4 text-[#fe150a] fill-[#fe150a]" />
            <span className="text-sm text-[#431908] font-sans">by</span>
            <a
              href="https://rb2.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-[#fe150a] hover:text-[#e31700] font-sans flex items-center"
            >
              rb2
            </a>
          </div>
          <div className="text-xs text-[#431908] font-sans">
            © {getCopyrightYears()} rb2. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
